// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__ND_cU","title":"card_title__meItF","inActive":"card_inActive__2j6p7"};